import React from 'react';
import { CSSObject } from '@emotion/react';
import useBreakpoints from '@hooks/useBreakpoints';
import DateTimeRange from '@components/shared/DateTimeRange';

interface DateRangeSubheader {
  startDate: string;
  endDate: string;
}

const useStyles = (): Record<string, CSSObject> => {
  const breakpoints = useBreakpoints();
  const { mediaIsMobile, mediaIsM } = breakpoints;

  return {
    subHeaderIcon: {
      marginRight: 7,
      verticalAlign: 'middle',
      display: 'inline-block',
      [mediaIsMobile]: {
        display: 'inline-flex'
      }
    },
    subHeaderText: {
      marginTop: 0,
      marginBottom: 0,
      display: 'flex',
      textAlign: 'center',
      width: '100%',
      whiteSpace: 'nowrap',
      fontSize: '1.125rem',
      [mediaIsMobile]: {
        justifyContent: 'flex-start',
        fontSize: '0.75rem'
      },
      [mediaIsM]: {
        justifyContent: 'flex-start'
      },
      justifyContent: 'flex-start'
    }
  };
};

function DateRangeSubheader({ startDate, endDate }: DateRangeSubheader): JSX.Element {
  const { subHeaderText } = useStyles();

  return (
    <span css={subHeaderText}>
      {/* outer span keeps icon in-line on text line break */}
      <span>
        <DateTimeRange startDate={new Date(startDate)} endDate={new Date(endDate)} />
      </span>
    </span>
  );
}

export default DateRangeSubheader;
